import { useState } from "react";

const ToggleButton = ({ withIcon = false, darkMode = false }) => {
  const [isOn, setIsOn] = useState(false);
  const toggle = () => setIsOn((prv) => !prv);
  return (
    <button className={`${withIcon && "toogle-with-icon"} ${darkMode && "dark-mode"} ${isOn ? "on" : "off"}`} id="toggle" onClick={toggle}>
      <span className="toggle-pin" />
    </button>
  );
};

export default ToggleButton;
